module.exports = __webpack_public_path__ + "static/media/Comprehensive Quality Assessment Report Jul.2024 Dai Hung - Block 05.1a.cd5a13e6.pdf";